import { Controller } from '@hotwired/stimulus'
import { UnitPreferenceService } from '../services/unit-preference-service'
import { UnitDisplayUpdater } from '../services/unit-display-updater'

export default class extends Controller {
  static targets = ['label', 'sizeDisplay', 'unitDisplay']
  static values = {
    targetUnit: String,
    metricLabel: String,
    imperialLabel: String
  }

  connect() {
    this.preferenceService = new UnitPreferenceService()
    this.displayUpdater = new UnitDisplayUpdater({
      metric: this.metricLabelValue,
      imperial: this.imperialLabelValue
    })
    this.displayUpdater.updateLabels(this.labelTargets, this.targetUnitValue)
  }

  async toggle(event) {
    event.preventDefault()

    const targetUnit = this.targetUnitValue
    const newUnit = this.oppositeUnit(targetUnit)

    this.switchToUnit(targetUnit, newUnit)

    try {
      await this.preferenceService.save(targetUnit)
    } catch (error) {
      console.error(error.message)
      this.switchToUnit(newUnit, targetUnit)
    }
  }

  switchToUnit(displayUnit, nextTargetUnit) {
    const allDisplays = [...this.sizeDisplayTargets, ...this.unitDisplayTargets]
    this.displayUpdater.updateDisplays(allDisplays, displayUnit)
    this.targetUnitValue = nextTargetUnit
    this.displayUpdater.updateLabels(this.labelTargets, nextTargetUnit)
  }

  oppositeUnit(unit) {
    return unit === 'imperial' ? 'metric' : 'imperial'
  }
}
